<template>
  <div class="produto-codigos-vinculo">
    <div v-if="erroModulo" class="ui message warning">
      {{ erroModulo }}
    </div>
    <template v-else>
      <div class="ui segment">
        <h4 class="ui header dividing">Vincular código</h4>
        <form class="ui form" @submit.prevent="adicionarCodigo">
          <div class="fields" style="margin-bottom: 0;">
            <div class="twelve wide field">
              <input
                v-model="novoCodigo"
                type="text"
                maxlength="96"
                placeholder="Informe o código de identificação"
                :disabled="enviando || !produto"
              >
            </div>
            <div class="four wide field">
              <button
                type="submit"
                class="ui button purple fluid"
                :class="{ loading: enviando }"
                :disabled="enviando || !produto || !novoCodigo.trim()"
              >
                Adicionar código
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="ui segment">
        <h4 class="ui header dividing">Códigos ativos</h4>
        <table class="ui celled compact table small">
          <thead>
            <tr>
              <th>Código</th>
              <th>Usuário</th>
              <th>Vinculado em</th>
              <th class="two wide center aligned">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in vinculosAtivos" :key="item.recnum">
              <td style="word-break: break-all;">{{ item.codigo }}</td>
              <td>{{ item.usuario }}</td>
              <td>{{ formatarDataHora(item.created_at) }}</td>
              <td class="center aligned">
                <button
                  type="button"
                  class="ui button orange mini icon"
                  title="Inativar (código bloqueado)"
                  @click="confirmarInativar(item)"
                >
                  <i class="icon ban" />
                </button>
                <button
                  type="button"
                  class="ui button red mini icon"
                  title="Excluir (código reutilizável)"
                  @click="confirmarExcluir(item)"
                >
                  <i class="icon trash" />
                </button>
              </td>
            </tr>
            <tr v-if="!vinculosAtivos.length && !carregando">
              <td colspan="4" class="center aligned">Nenhum código ativo</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ui segment">
        <h4 class="ui header dividing">Histórico (inativos)</h4>
        <table class="ui celled compact table small">
          <thead>
            <tr>
              <th>Código</th>
              <th>Usuário</th>
              <th>Vinculado em</th>
              <th>Inativado em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in vinculosHistorico" :key="'h-' + item.recnum">
              <td style="word-break: break-all;">{{ item.codigo }}</td>
              <td>{{ item.usuario }}</td>
              <td>{{ formatarDataHora(item.created_at) }}</td>
              <td>{{ formatarDataHora(item.inativado_em || item.updated_at) }}</td>
            </tr>
            <tr v-if="!vinculosHistorico.length && !carregando">
              <td colspan="4" class="center aligned">Nenhum código inativo</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/services/api';

export default {
  name: 'ProdutoCodigosVinculo',
  data() {
    return {
      produto: '',
      novoCodigo: '',
      vinculosAtivos: [],
      vinculosHistorico: [],
      carregando: false,
      enviando: false,
      erroModulo: '',
    };
  },
  created() {
    this.produto = (this.$route.query.produto || '').trim();
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      if (!this.produto) {
        this.erroModulo = 'Informe o produto para listar os códigos.';
        return;
      }

      this.carregando = true;
      this.erroModulo = '';
      try {
        const [ativos, historico] = await Promise.all([
          api.get('/api/servicos/produto-codigo-vinculo', {
            params: { produto: this.produto },
          }),
          api.get('/api/servicos/produto-codigo-vinculo', {
            params: { produto: this.produto, historico: 1 },
          }),
        ]);
        this.vinculosAtivos = ativos.data.data || [];
        this.vinculosHistorico = historico.data.data || [];
      } catch (error) {
        const status = error.response?.status;
        const msg = error.response?.data?.message;
        if (status === 403) {
          this.erroModulo = msg || 'Módulo de expedição não disponível para esta empresa.';
        } else {
          this.$alertify.error(msg || 'Erro ao carregar códigos.');
        }
      } finally {
        this.carregando = false;
      }
    },
    async adicionarCodigo() {
      const codigo = (this.novoCodigo || '').trim();
      if (!codigo || this.enviando) {
        return;
      }

      this.enviando = true;
      try {
        await api.post('/api/servicos/produto-codigo-vinculo', {
          produto: this.produto,
          codigo,
        });
        this.novoCodigo = '';
        this.$alertify.success('Código vinculado.');
        await this.carregar();
      } catch (error) {
        this.$alertify.error(error.response?.data?.message || 'Erro ao vincular código.');
      } finally {
        this.enviando = false;
      }
    },
    formatarDataHora(valor) {
      if (!valor) return '—';
      return moment(valor).format('DD/MM/YYYY HH:mm');
    },
    confirmarInativar(item) {
      this.$alertify.confirm(
        'Inativar bloqueia o código para reutilização. Deseja continuar?',
        async () => {
          try {
            await api.put(`/api/servicos/produto-codigo-vinculo/${item.recnum}/inativar`);
            this.$alertify.success('Código inativado.');
            await this.carregar();
          } catch (error) {
            this.$alertify.error(error.response?.data?.message || 'Erro ao inativar código.');
          }
        },
        () => true,
      );
    },
    confirmarExcluir(item) {
      this.$alertify.confirm(
        'Excluir remove o vínculo e libera o código. Deseja continuar?',
        async () => {
          try {
            await api.delete(`/api/servicos/produto-codigo-vinculo/${item.recnum}`);
            this.$alertify.success('Vínculo excluído.');
            await this.carregar();
          } catch (error) {
            this.$alertify.error(error.response?.data?.message || 'Erro ao excluir código.');
          }
        },
        () => true,
      );
    },
  },
};
</script>

<style scoped>
.produto-codigos-vinculo {
  padding: 8px 12px 16px;
}
</style>
